/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-08-09 15:32:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-01 15:02:23
 * @FilePath: /mall-fe/src/comps/FixedMenu.tsx
 * @Description: 悬浮客服快捷入口组件
 *
 */
import { Affix, Popover, Modal, Button, Tooltip } from 'antd';
import QQIcon from 'icons/newQQ.svg';
import QRcode from 'icons/qr-code.svg';
import Kefu from 'icons/service.svg';
import Fankui from 'icons/feedback.svg';
import Portal from 'icons/portal.svg';
import ImgTopQRNew from 'images/cscec3b/menu-qr-new.jpg';
import { SiteContext, UserContext } from 'libs/contexts';
import { useContext, useEffect, useState, useRef } from 'react';
import serviceHead from 'images/cscec3b/service-head.png';
import { useRouter } from 'next/router';
import { getWofengService } from 'api/common';
import { getUserDetail } from 'api/user';
import { getWofengServiceParams } from 'libs/utils';
import { startDrag } from 'libs/drag';
import BackTop from 'comps/BackTop';
import { AccountBookOutlined } from '@ant-design/icons';
import IsExternalPurchaserUsed from '@/views/h5/my-center/shared/hooks/useIsExternalPurchaserUsed';
import { amI } from '@/libs/user';
import SelfOperatedOrganization from '@/views/h5/my-center/features/settlement/hooks/useSelfOperatedOrganization';
import { HELP_CENTER_URL_PREFIX } from 'libs/urls';
import { CurrentUserTypeSource } from 'libs/enums';
import { isInDop } from 'libs/dopUtil.js';
import useQueryServiceOpenStatus from '@/hooks/useQueryServiceOpenStatus';

const FixedMenu = ({ supplierSysNo }) => {
  const site = useContext(SiteContext);
  const userInfo = useContext(UserContext);
  const [visible, setVisible] = useState<boolean>(false);
  const router = useRouter();
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  // 拖拽区域
  const dragBoxRef = useRef(null);
  // 拖拽移动区域
  const moveBoxRef = useRef(null);
  const isSupplier = amI(userInfo, 'supplier');
  const selfOperatedOrganization = SelfOperatedOrganization();
  const { showKefu } = useQueryServiceOpenStatus();
  const canShowEnquiry =
    !userInfo || (!selfOperatedOrganization && (IsExternalPurchaserUsed() || isSupplier));
  // 客服咨询
  const toService = async () => {
    if (userInfo?.name) {
      const { data } = await getUserDetail();
      const transferData = {
        profile: data.profile,
        applications: data.applications,
        supplierSysNo,
      };
      const params = await getWofengServiceParams(transferData);
      const res = await getWofengService(params);
      if (res.code === 200) {
        window.open(res.data?.url, '_blank');
      }
      return;
    } else {
      setVisible(true);
    }
  };
  // 问题反馈
  const toFeedback = async () => {
    let linkUrl = `${HELP_CENTER_URL_PREFIX}/feedbackJumpPage?code=`;
    if (userInfo?.name) {
      const { data = {} } = await getUserDetail();
      linkUrl = `${linkUrl}${data.profile?.sysNo || ''}`;
    }
    window.open(linkUrl, '_blank');
  };
  // 去登录
  const toLogin = () => {
    setVisible(false);
    const retUrl = `${location.protocol}//${location.host}${router.pathname}`;
    router.push(`/sso/xlogin?return_url=${encodeURIComponent(retUrl)}`);
  };
  // 游客-客服咨询
  const visitorToService = async () => {
    const transferData = {
      profile: null,
      applications: [],
      supplierSysNo,
    };
    const params = await getWofengServiceParams(transferData);
    const res = await getWofengService(params);
    if (res.code === 200) {
      setVisible(false);
      window.open(res.data?.url, '_blank');
    }
  };
  // 弹窗关闭
  const onCancel = () => {
    setVisible(false);
  };
  const toEnquiry = () => {
    router.push('/enquiry');
  };
  // 默认仅首页开启tooltip
  useEffect(() => {
    startDrag(dragBoxRef.current, moveBoxRef.current.fixedNode);
    const tooltipStorage = sessionStorage.getItem('TOOLTIP_STORAGE');
    if (location.pathname === '/' && !tooltipStorage) {
      setShowTooltip(true);
      sessionStorage.setItem('TOOLTIP_STORAGE', '1');
      setTimeout(() => {
        setShowTooltip(false);
      }, 3000);
    }
  }, []);

  const portalURL =
    userInfo?.currentUserType === CurrentUserTypeSource.personal
      ? `/portal?perferKey=personal`
      : '/portal/';
  const [inDop, setInDop] = useState(false);

  const checkDopInfo = async () => {
    setInDop(await isInDop());
  };

  useEffect(() => {
    checkDopInfo();
  }, []);
  return (
    <div className="fixed_menu_box">
      <Affix offsetBottom={200} className="fix_menu" ref={moveBoxRef}>
        <div className="menu_box">
          <div className="serviceHead" key={'serviceHead'} ref={dragBoxRef}>
            <img src={serviceHead} alt="客服咨询" width={48} height={48} draggable="false" />
          </div>

          {showKefu && (
            <div key={'Kefu'}>
              <Tooltip
                placement="left"
                title="有任何问题可以咨询客服"
                getPopupContainer={(triggerNode) => triggerNode}
                color="#ff0000"
                visible={showTooltip}
                destroyTooltipOnHide={true}
              >
                <div className="item" onClick={toService}>
                  <Kefu />
                </div>
              </Tooltip>
            </div>
          )}

          <div key={'QQ'}>
            <Popover
              placement="left"
              className="fix_menu_popover"
              getPopupContainer={(triggerNode) => triggerNode}
              content={
                <div className="list_box">
                  {/* <div className="list_item">
                    <QQIcon />
                    <div className="contact">
                      <div className="name">采购商QQ咨询群</div>
                      <div className="number">387339264</div>
                    </div>
                  </div> */}
                  <div className="list_item">
                    <QQIcon />
                    <div className="contact">
                      <div className="name">供应商咨询3群</div>
                      <div className="number">766095587</div>
                    </div>
                  </div>
                </div>
              }
              trigger="hover"
            >
              <div className="item">
                <QQIcon />
              </div>
            </Popover>
          </div>
          {userInfo && userInfo.name ? (
            <div key={'Portal'} title="工作台">
              <div
                className="item"
                onClick={() => {
                  window.selfOpen(portalURL, inDop ? '_blank' : '_top');
                }}
              >
                <Portal />
              </div>
            </div>
          ) : null}
          <div key={'QRcode'}>
            <Popover
              placement="left"
              className="fix_menu_popover"
              getPopupContainer={(triggerNode) => triggerNode}
              content={
                <div className="qop_qr_box">
                  <img className="top_qr" src={ImgTopQRNew} alt="二维码" />
                </div>
              }
              trigger="hover"
            >
              <div className="item">
                <QRcode />
              </div>
            </Popover>
          </div>
          {!!canShowEnquiry && (
            <Popover
              placement="left"
              className="fix_menu_popover"
              getPopupContainer={(triggerNode) => triggerNode}
              content={<div className="list_enquiry">我要询价</div>}
              trigger="hover"
            >
              <div className="item" onClick={toEnquiry}>
                <AccountBookOutlined style={{ fontSize: '24px' }} />
              </div>
            </Popover>
          )}
          {userInfo && userInfo.name ? (
            <Popover
              placement="left"
              className="fix_menu_popover"
              getPopupContainer={(triggerNode) => triggerNode}
              content={<div className="list_enquiry">问题反馈</div>}
              trigger="hover"
            >
              <div key={'Feedback'}>
                <div className="item" onClick={toFeedback}>
                  <Fankui />
                </div>
              </div>
            </Popover>
          ) : null}
        </div>
      </Affix>
      <BackTop />
      <Modal
        visible={visible}
        title="提示"
        onCancel={onCancel}
        footer={[
          <Button key={'visitor'} onClick={visitorToService}>
            访客咨询
          </Button>,
          <Button key={'login'} onClick={toLogin} type="primary">
            去登录
          </Button>,
        ]}
      >
        <span>您当前尚未登录，请先登录或以访客身份咨询客服。</span>
      </Modal>
      <style jsx>{`
        .fixed_menu_box {
          font-family: "PingFang SC";
          font-style: normal;
        }
        :global(.fix_menu) {
          width: 48px;
          text-align: center;
          cursor: pointer;
          z-index: 999;
          color: ${site?.global?.platformMainColor};
          border-radius: 1px;
          position: fixed;
        }
        :global(.ant-affix) {
          width: 48px;
          right: 24px;
          box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
        }
        .item {
          width: 48px;
          height: 48px;
          background-color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .item :hover {
          background-color: ${site?.global?.platformMainColor};
        }
        .item :hover :global(svg path) {
          fill: #fff;
        }
        .list_box {
          padding: 12px;
          width: 200px;
          border: 1px solid #e6ebf5;
        }
        .list_item {
          margin-bottom: 12px;
          display: flex;
        }
        .list_item:last-child {
          margin-bottom: 0;
        }
        .list_item:hover .name {
          color: ${site?.global?.platformMainColor};
        }
        .list_item:hover .number {
          color: #333333;
        }
        .name {
          font-size: 14px;
          color: #333333;
          line-height: 14px;
          margin-bottom: 4px;
        }
        .number {
          font-size: 12px;
          color: #999999;
          line-height: 12px;
        }
        .qop_qr_box {
          padding: 12px;
          border: 1px solid #e6ebf5;
        }
        .top_qr {
          width: 421px;
          height: 175px;
        }
        :global(.ant-popover-placement-left .ant-popover-inner-content) {
          padding: 0;
        }
        .menu_box {
          position: relative;
        }
        .serviceHead {
          position: absolute;
          left: 0;
          top: -40px;
          cursor: grab;
        }
        .serviceHead img {
          vertical-align: middle;
        }
      
        :global(.ant-tooltip-inner) {
          color: #fff;
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
        }
        .list_item :global(svg path) {
          fill: #018dd7 !important;
        }
        .fix_menu_popover :global(.ant-popover-inner) {
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          overflow: hidden;
        }
        .contact {
          margin-left: 8px;
        }
        .list_enquiry {
          padding: 4px 12px;
          color: var(--rv-primary-color);
        }
      `}</style>
    </div>
  );
};

export default FixedMenu;
